import React, { Component } from "react";
import "../../../src/styles/button_style.scss";

import SignInFacebook from "./SignInFacebook.js";
import "../../styles/rocket.scss";

import earth from "../images/earth.png";
import Modal from "react-modal";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class ErrorScreen extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: false
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <div class="welcome-screen-gira">
        <div class="welcome">
          <Modal
            style={{ maxWidth: "800px" }}
            className="quiz-modal card "
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal}
            shouldFocusAfterRender={false}
            shouldCloseOnOverlayClick={false}
            shouldCloseOnEsc={false}
            contentLabel="Example Modal"
          >
            <div className="Welcome-modal-container">
              <h2>Pick your Avatar!</h2>
              <p>
                This avatar will be your guide throughout the rest of the game.
              </p>

              <div className="choose-avatar--container">
                {/* Icons made by Freepik Freepik, and its source is from Flaticon.com. Read more at the following link https://www.freepik.com/?__hstc=57440181.8e50b6dfdda3149e4e4a602d60bd29b3.1556538778858.1558350244779.1558354470696.6&__hssc=57440181.9.1558354470696&__hsfp=1601669549 */}
                <img
                  onClick={() => {
                    this.closeModal();
                    this.props.pickAvatar("Koala");
                  }}
                  src={koala}
                  alt="Koala"
                />
                <img
                  onClick={() => {
                    this.closeModal();
                    this.props.pickAvatar("Fox");
                  }}
                  src={fox}
                  alt="Fox"
                />
                <img
                  onClick={() => {
                    this.closeModal();
                    this.props.pickAvatar("Lemur");
                  }}
                  src={lemur}
                  alt="Lemur"
                />
                <img
                  onClick={() => {
                    this.closeModal();
                    this.props.pickAvatar("Zebra");
                  }}
                  src={zebra}
                  alt="Zebra"
                />
              </div>
            </div>
          </Modal>

          <div className="MobileSpacing">
            {!localStorage.hasOwnProperty("totalscore") &&
              this.props.updateScore(0)}
          </div>
          <div className="error-text">
            <h3>Please write your name</h3>
          </div>

          <h2 style={{ color: "#ffffff" }}>Welcome to </h2>
          <h1 style={{ color: "#ffffff" }}> Gira the</h1>
          <h1 style={{ color: "#52b452dc" }}> Explorer</h1>

          <br />
          <br />

          <div className="MobileSpacing">
            <br /> <br />
          </div>
          {/* <video nocontrols autoplay loop muted height="300px">
            <source src={koalaVideo} type="video/mp4" />
            </video> */}

          <div className="MobileSpacing">
            <br />
            <br />
          </div>
          <br />

          <br />
          <br />
          <br />
          <br />

          <br />
          <div className="small-instruction-text">
            <p>A web application game based on a</p>
            <p>dynamic street view map where you guess</p>
            <p>your location and answer quiz questions.</p>
          </div>
          <br />
          <div className="log-in-buttons">
            <SignInFacebook login={this.props.login} />
            <div
              className="separator--container"
              style={{ textAlign: "horizontal" }}
            >
              <div class="separator">or</div>
            </div>
            <form onSubmit={this.props.handleNameSubmit}>
              {/*keep onSubmit call here on form*/}
              <input
                className="form-style removeBorderRadiusInput"
                name="nameInput"
                placeholder="Enter your name"
              />{" "}
              {/*keep name="nameInput" */}
              <button className="cta-button removeBorderRadius">
                Start the game
              </button>
            </form>
          </div>
          <a href="https://github.com/team-datagram-rocket/Gira-the-explorer-application/blob/master/docs/Privacy_policy.md">
            Privacy Policy &nbsp; | &nbsp;
          </a>

          <a href="https://github.com/team-datagram-rocket/Gira-the-explorer-application">
            Copyright &copy; 2019 - The Gira Team &nbsp; | &nbsp;
          </a>

          <a href="https://github.com/team-datagram-rocket/Gira-the-explorer-application">
            GitHub
          </a>
        </div>
        <div className="change-avatar--card__container">
          <div>
            <img
              height="60px"
              src={
                localStorage.getItem("avatar") === "Koala"
                  ? koala
                  : localStorage.getItem("avatar") === "Fox"
                  ? fox
                  : localStorage.getItem("avatar") === "Lemur"
                  ? lemur
                  : localStorage.getItem("avatar") === "Zebra"
                  ? zebra
                  : koala
              }
              alt="koala"
            />
          </div>
          <div>
            <p>
              Your Avatar:
              <span style={{ color: "#52b452" }}>
                {" "}
                &nbsp;
                {localStorage.hasOwnProperty("avatar")
                  ? localStorage.getItem("avatar")
                  : "Koala"}
              </span>
            </p>
            <button
              onClick={() => {
                this.openModal();
              }}
              className="cta-button"
            >
              Change avatar
            </button>
          </div>
        </div>

        <div class="rocket">
          <br />
          <br />
          <br />

          <div className="earth">
            <img src={earth} alt="Earth" width="900pt" height="auto" />
          </div>

          <div class="rocket-body">
            <div class="body" />
            <div class="fin fin-left" />
            <div class="fin fin-right" />

            <div class="window">
              <div className="koala">
                <img src={koala} alt="Koala" width="60pt" height="auto" />
              </div>
            </div>
          </div>
          <div class="exhaust-flame" />
          <ul class="exhaust-fumes">
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
          </ul>

          <ul class="star">
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
            <li />
          </ul>
        </div>
      </div>
    );
  }
}
